import { isRequestError } from '~/common/services/requests';
import { isObject } from '../../utils/general';

const extractMessageFromPayload = (payload: unknown): string | undefined => {
  if (!isObject(payload)) return undefined;

  // Shape A: { error }
  if (typeof payload.error === 'string' && payload.error) return payload.error;

  // Shapes B/C/D: { message }
  if (typeof payload.message === 'string' && payload.message) {
    return payload.message;
  }

  // Shape E: { errors: { '*': ... } } — general error under the wildcard key
  if (isObject(payload.errors)) {
    const general = payload.errors['*'];
    if (typeof general === 'string') return general;
    if (Array.isArray(general) && typeof general[0] === 'string') {
      return general[0];
    }
  }

  return undefined;
};

/**
 * Extracts a human-readable message from a caught error, checking each known
 * incept-api error shape in priority order. Pass the raw caught value — axios
 * errors are unwrapped automatically via `isRequestError`. Returns `fallback`
 * when no usable message is found.
 */
export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Something went wrong',
): string => {
  const payload = isRequestError(error) ? error.response?.data : error;
  return extractMessageFromPayload(payload) ?? fallback;
};
